export default __webpack_public_path__ + "static/media/womanandgun.c0bd9dce.jpg";